import {
  Box,
  CardHeader,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { formatSchedulerDate, INFO_TYPE } from "hhn-commons";
import React from "react";

function ScheduleHeader(props: {
  addresses: any;
  value: INFO_TYPE;
  onChange: (event: React.MouseEvent<HTMLElement>, newValue: number) => void;
}) {
  console.log(
    "props.addresses[0].schedulerDate ==>",
    props.addresses[0].schedulerDate,
  );
  console.log(
    "formatSchedulerDate ==>",
    formatSchedulerDate(props.addresses[0].schedulerDate),
  );
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <CardHeader
        title="Schedule"
        subheader={formatSchedulerDate(props.addresses[0].schedulerDate)}
      />
      <ToggleButtonGroup
        color="primary"
        value={props.value}
        exclusive
        onChange={props.onChange}
        aria-label="Platform"
        size="small"
      >
        <ToggleButton value={INFO_TYPE.DEFAULT}>Default</ToggleButton>
        <ToggleButton value={INFO_TYPE.SUGGESTED}>Suggested</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default ScheduleHeader;
